import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from "firebase";
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-blog-category',
    templateUrl: './blog-category.component.html',
    styleUrls: ['./blog-category.component.scss'],
})
export class BlogCategoryComponent implements OnInit, OnDestroy {
    form: FormGroup;
    formErrors: any;
    imageName: any;
    queryString: any;
    files: any[] = [];
    isUploading = false;
    public progress: number;
    urls = new Array<string>();


    constructor(private formBuilder: FormBuilder, private afs: AngularFirestore,
        private activatedRoute: ActivatedRoute) {

        this.formErrors = {
            category: {}

        };
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            category: ['', Validators.required]


        });
        this.queryString = this.activatedRoute.snapshot.queryParams['key'];
        if (this.queryString) {
            this.afs.collection('blogCategories').doc(this.queryString).ref.get().then(data => {
                this.form = this.formBuilder.group({
                    category: data.data().name


                });
                this.imageName = data.data().image

            });
        }

    }

    changeTextCategory(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/-/g, '')
            .replace(/\./g, '-')
            .replace(/\'/g, '')
            .replace(/\s/g, '-').toLowerCase();
    }

    getGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    detectFiles(event) {
        this.urls = [];
        let files = event.target.files;
        if (files) {
            for (let file of files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.urls.push(e.target.result);
                    console.log(e.target.result);
                    var storageRef = firebase.storage().ref();
                    let newFileName = this.getGUID();
                    this.imageName = newFileName;

                    var uploadTask = storageRef.child('files/' + newFileName).putString(e.target.result, "data_url");
                    this.upload(uploadTask, () => {
                        let media = {
                            type: "image",
                            name: newFileName
                        };
                        this.files.push(media);






                    });
                }
                reader.readAsDataURL(file);
            }
        }
    }
    upload(uploadTask, callback) {
        this.isUploading = true;
        uploadTask.then(() => callback());
        // Register three observers:
        // 1. 'state_changed' observer, called any time the state changes
        // 2. Error observer, called on failure
        // 3. Completion observer, called on successful completion
        uploadTask.on('state_changed', (snapshot: firebase.storage.UploadTaskSnapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            this.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    break;
            }
        }, (error: firebase.FirebaseError) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
                case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break;

                case 'storage/canceled':
                    // User canceled the upload
                    break;
                case 'storage/unknown':
                    // Unknown error occurred, inspect error.serverResponse
                    break;
            }
        }, () => {
            this.isUploading = false;
        });
    }
    changeText(string) {
        return string
            .trim()
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '')
            .replace(/\-/g, '')
            .replace(/\'/g, '')
            .replace(/\s/g, '')
            .toLowerCase();
    }


    send() {

        if (this.imageName && !this.queryString) {
            this.afs.collection('blogCategories').add({
                name: this.form.value.category,
                image: this.imageName,
                uniqueName: this.changeText(this.form.value.category)



            });
            this.form.reset();
        }
        else if (this.queryString) {

            this.afs.collection('blogCategories').doc(this.queryString).update({
                name: this.form.value.category,
                image: this.imageName,
                uniqueName: this.changeText(this.form.value.category)
            });
            this.form.reset();


        }



    }


    ngOnDestroy() {

    }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog-category/blog-category.component.ts